import {
  Button,
  FormControl,
  InputAdornment,
  Dialog,
  DialogContent,
  InputLabel,
  MenuItem,
  CircularProgress,
  Select,
  SpeedDial,
  TextField, Modal
} from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import TaskFilter from "../components/task-filter";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";



import { Box } from "@mui/system";

const getCookie = require("../utils/getCookie");

const Home = (props) => {
  const { logged } = props;
  const [pesquisa, setPesquisa] = useState("");
  const [respostas, setrespostas] = useState([]);
  const [setor, setSetor] = useState([]);
  // alert(JSON.stringify(props.logged))
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [fkArea, setfkArea] = useState("");
  const [subarea, setSubArea] = useState([]);
  const [meuSetor, setMeuSetor] = useState([]);
  const [todosEmails, setEmails] = useState([]);
  const [fechar, setFechar] = useState(false);
  const [filtro, setFiltro] = useState(false);
  const [emailNaoEncontrado, setEmailNaoEncontrado] = useState(false);
  const [statusFiltro, setStatusFiltro] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [loading, setLoading] = useState(true); // Novo estado para controlar o carregamento




  //  const nome = Logged.Perfil.nome;
  const [minhasAtividades, setMinhasAtividades] = useState([]);
  const [minhasAtividadesAntigas, setMinhasAtividadesAntigas] = useState([]);
  const [solicitacaoAtividades, setSolicitacaoAtividades] = useState([]);
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [minhas, setMinhas] = useState(true);
  const [minhas2, setMinhas2] = useState(false);
  // const [fkUnidade, setFkUnidade]= useState(props.logged.Area.fkUnidade)

  function carregarSolicitacaoAtividades() {
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/atividade/chamadosAbertos/`,
      params
    ).then((response) => {
      const { status } = response;
      response.json().then((data) => {
        if (status === 401) {
        } else if (status === 200) {
          // alert(JSON.stringify(data.data))

          setSolicitacaoAtividades(data.data);

          // alert('oi ' +JSON.stringify( minhasAtividades))
          // setUsuariosNaoValidados(data.data)
        }
      });
    });
  }

  function carregarAtividadesDoSetor() {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/atividade/recebidasSetor/`,
      params
    ).then((response) => {
      const { status } = response;
      response.json().then((data) => {
        setOpenLoadingDialog(false);
        if (status === 401) {
        } else if (status === 200) {
          setOpenLoadingDialog(false);

          // alert(JSON.stringify(data.data))

          setMeuSetor(data.data);
        }
      });
    });
  }

  function carregarEmails() {
    setOpenLoadingDialog(true);
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/email/`, params).then(
      (response) => {
        const { status } = response;
        response.json().then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
          } else if (status === 200) {
            setOpenLoadingDialog(false);

            // alert(JSON.stringify(data.data))

            setEmails(data.data);
          }
        });
      }
    );
  }

  function carregarMinhasAtividades() {
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/atividade/minhasAtividades/`,
      params
    ).then((response) => {
      const { status } = response;
      response.json().then((data) => {
        if (status === 401) {
        } else if (status === 200) {
          // alert(JSON.stringify(data.data))

          setMinhasAtividades(data.data);

          // alert('oi ' +JSON.stringify( minhasAtividades))
          // setUsuariosNaoValidados(data.data)
        }
      });
    });
  }

  const timer = setTimeout(() => {
    if (minhasAtividadesAntigas.length > 0) {
      setShowModal(true); // Abre o modal após 5 segundos se houver atividades
    }
  }, 5000);

  function carregarMinhasAtividadesAntigas() {
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/atividade/minhasAtividadesAntigas/`,
      params
    ).then((response) => {
      const { status } = response;
      response.json().then((data) => {
        if (status === 401) {
        } else if (status === 200) {
          // alert(JSON.stringify(data.data))

          setMinhasAtividadesAntigas(data.data[0]);

          // alert('oi ' +JSON.stringify( minhasAtividades))
          // setUsuariosNaoValidados(data.data)
        }
      });
    });
  }
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const Change = (event) => {
    setMinhas(event.target.checked);
  };

  const Change2 = (event) => {
    setMinhas2(event.target.checked);
  };

  useEffect(() => {
    carregarMinhasAtividadesAntigas();

    const timer = setTimeout(() => {
      if (minhasAtividadesAntigas.length > 0) {
        setShowModal(true); // Abre o modal após 5 segundos se houver atividades
      }
      setLoading(false); // Define o carregamento como concluído após 5 segundos
    }, 5000);

    // Limpar o timeout quando o componente for desmontado
    return () => clearTimeout(timer);
  }, []); // Dependência para garantir que useEffect execute corretamente



  const calculateDaysSince = (date) => {
    const today = new Date();
    const creationDate = new Date(date);
    const diffTime = Math.abs(today - creationDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const loa = {
    loadingContainer: {
      display: 'flex',
      // flexDirection: 'column',
      // alignItems: 'center',
      // justifyContent: 'center',
      // height: '100vh',
    },
  };


  useEffect(() => {
    carregarMinhasAtividades();
    // carregarMinhasAtividadesAntigas();
    carregarSolicitacaoAtividades();
    carregarAtividadesDoSetor();
    // carregarEmails();method



    if (todosEmails && logged) {
      let encontrado = false;
      todosEmails.forEach((emailObj) => {
        if (emailObj.email === props.logged.email) {
          encontrado = true;
        }
      });

      if (!encontrado && !fechar) {
        setEmailNaoEncontrado(true);
      }
    }
  }, [todosEmails, emailNaoEncontrado]);

  useEffect(() => {
    if (pesquisa) {
      pesquisar();
    }


    // if(meuSetor.length){
    //   alert(JSON.stringify(meuSetor))
    // }

    // if(logged)
    // {alert(JSON.stringify(logged))}
  }, [pesquisa]);

  // useEffect(() => {
  //   pesquisa()
  // }, [pesquisa])

  function pesquisar() {
    const token = getCookie("_token_task_manager");
    const params = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    // fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade${pesquisa?`/search?&pesquisa=${pesquisa}` : ''
    fetch(
      `${process.env.REACT_APP_DOMAIN_API}/api/atividade/search?pesquisa=${pesquisa}`,
      params
    ).then((response) => {
      const { status } = response;
      response
        .json()
        .then((data) => {
          // setOpenLoadingDialog(false)

          if (status === 401) {
            // alert(status)
          } else if (status === 200) {
            // alert(pesquisa)
            // alert(JSON.stringify(data.data))
            setrespostas(data.data);
            // alert(JSON.stringify(respostas))
            // filtrarUsuariosDemandados()
          }
        })
        .catch((err) => console.log(err));
    });
  }

  useEffect(() => {
    function carregarSetor() {
      // setOpenLoadingDialog(true)
      const token = getCookie("_token_task_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/area/?fkUnidade=${logged ? logged.Area.fkUnidade : ""
        }`,
        params
      ).then((response) => {
        const { status } = response;
        response
          .json()
          .then((data) => {
            setOpenLoadingDialog(false);
            if (status === 401) {
            } else if (status === 200) {
              setSetor(data.data);
              setOpenLoadingDialog(false);
            }
          })
          .catch((err) => setOpenLoadingDialog(true));
      });
    }

    if (checked) {
      carregarSetor();
    }
  }, [checked]);

  useEffect(() => {
    function carregarSubArea() {
      // setOpenLoadingDialog(true)
      const token = getCookie("_token_task_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/subarea/?fkArea=${fkArea}`,
        params
      ).then((response) => {
        const { status } = response;
        response
          .json()
          .then((data) => {
            setOpenLoadingDialog(false);
            if (status === 401) {
            } else if (status === 200) {
              setSubArea(data.data);
              setOpenLoadingDialog(false);
            }
          })
          .catch((err) => setOpenLoadingDialog(true));
      });
    }

    if (fkArea) {
      carregarSubArea();
    }
  }, [fkArea]);
  const styles = {
    table: {
      fontFamily: "Arial, sans-serif",
      fontSize: "14px",
      margin: "10px 20px",
      borderCollapse: "collapse",
      boxShadow: "0 0 8px rgba(0, 0, 0, 0.2)",
      borderRadius: "5px",
      width: "100%",
      backgroundColor: "#f9f9f9",
    },
    thead: {
      backgroundColor: "#f1f1f1",
    },
    th: {
      padding: "12px", // Aumentei o padding para mais formalidade
      borderBottom: "2px solid #ddd",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "16px",
      color: "#333",
    },
    td: {
      padding: "10px",
      textAlign: "center",
    },
    button: (color) => ({
      backgroundColor: color,
      marginLeft: '10px',
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      padding: "8px 16px", // Aumentei o padding para deixar os botões mais robustos
      cursor: "pointer",
      fontSize: "14px", // Aumentei o tamanho da fonte
      boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)", // Sombreamento adicionado
      transition: "background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease", // Adicionei transições suaves
      outline: "none", // Remove o outline ao clicar
    }),
  };

  // Usar CSS tradicional para hover e active
  const stylesCSS = `
    button {
      transition: all 0.3s ease-in-out;
    }
    button:hover {
      box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
    }
    button:active {
      transform: scale(0.98);
    }
  `;

  const statusColors = {
    Aberto: "#007bff", // Azul
    Iniciado: "#28a745", // Verde
    Parado: "#ffc107", // Amarelo
    Pendente: "#dc3545", // Vermelho
    Planejado: "#5bc0de", // Azul claro
  };


  const prioridadeColors = {
    Baixa: "#007bff", // Azul
    Media: "#28a745", // Verde
    Alta: "#dc3545", // Amarelo
    Critica: "#c60e3d", // Vermelho
    NaoDefenido: "#5bc0de", // Azul claro
  };

  const StatusButton = ({ status }) => {
    const color = statusColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
    return (
      <button style={buttonStyle(color)}>
        {status}
      </button>
    );
  };

  const PrioridadeButton = ({ status }) => {
    const color = prioridadeColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
    return (
      <button style={buttonStyle2(color)}>
        {"Prioridade " + status}
      </button>
    );
  };

  const buttonStyle = (color) => ({
    backgroundColor: `${color}33`, // Cor com transparência (33 = 20% opacidade)
    color: color, // Texto na cor principal
    borderRadius: "12px", // Forma arredondada
    padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
    fontSize: "12px", // Tamanho de fonte menor
    fontWeight: "500", // Texto semi-negrito
    display: "inline-block", // Para se comportar como uma badge
    textAlign: "center", // Centraliza o texto
    border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
    marginLeft: "5px", // Margem para espaçamento
  });

  const buttonStyle2 = (color) => ({
    backgroundColor: `${color}80`, // Cor com transparência (33 = 20% opacidade)
    color: 'black', // Texto na cor principal
    borderRadius: "12px", // Forma arredondada
    padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
    fontSize: "12px", // Tamanho de fonte menor
    fontWeight: "500", // Texto semi-negrito
    display: "inline-block", // Para se comportar como uma badge
    textAlign: "center", // Centraliza o texto
    border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
    marginLeft: "5px", // Margem para espaçamento
  });
  const styles1 = {
    dialog: {
      display: 'flex',
      flexDirection: 'column',
      height: '80vh', // Ajuste a altura conforme necessário
    },
    dialogContent: {
      flex: 1,
      overflowY: 'auto',
    },
    tableBody: {
      backgroundColor: "#fff",
      color: "#333",
    },
    tableRow: {
      borderBottom: "1px solid #ddd",
      padding: "10px",
    },
    tableCell: {
      padding: "10px",
      verticalAlign: "top",
    },
    title: {
      fontWeight: "bold",
      color: "#444",
    },
    detail: {
      color: "#777",
    },
    executor: {
      color: "#007bff",
      fontStyle: "italic",
    },
    statusCompleted: {
      color: "#28a745",
      fontWeight: "bold",
    },
    statusPending: {
      color: "#dc3545",
      fontWeight: "bold",
    },
    button: {
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      padding: "6px 12px",
      cursor: "pointer",
      fontSize: "12px",
      transition: "background-color 0.3s",
    },
    buttonHover: {
      backgroundColor: "#0056b3",
    },
  };

  return (
    <div>
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        type="text/css"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
        integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
        crossorigin="anonymous"
      />

      {/* {logged ? <TaskFilter nome={props.logged.email} />
        :
        ''
      } */}
      <center>
        <div>
          {/* <Button size="large" variant="contained" style={{ marginRight: 20, marginTop: 20 }}
            onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/minhasAtividades/`} >
            Atividades Recebidas<KeyboardDoubleArrowLeftIcon /><div style={{ color: '#FFA500', fontWeight: 'bold', fontSize: 24 }}>{minhasAtividades.length}</div></Button><br></br>

          <Button size="large" variant="contained" style={{ marginRight: 20, marginTop: 20 }}
            onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/chamadosAbertos/`} >
            Atividades Solicitadas<KeyboardDoubleArrowRightIcon /><div style={{ color: '#FFA500', fontWeight: 'bold', fontSize: 24 }}>{solicitacaoAtividades.length}</div></Button><br></br> */}

          <Button
            size="large"
            variant="contained"
            style={{ marginRight: 20, marginTop: 20 }}
            onClick={() =>
              (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/cadastro`)
            }
          >
            Solicitar Atividade
          </Button>
          <br></br>
          <p></p>
        </div>
      </center>
      <center>
        {/* <div style={{ fontSize: 20, color: "#5499FA" }}>
          Recebidas por área
          <Switch
            label="Selecionar por Area"
            checked={checked}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div> */}
        {" "}
        <hr></hr>
        <b>
          Pendências do seu setor
        </b>
        <table style={styles.table}>
          <thead>

          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  {showModal ? (
                    <button
                      style={styles.button("#000000")}
                      onClick={() => setShowModal1(true)}
                    >
                      <b>⚠️Resolva suas antigas:</b> {minhasAtividadesAntigas.filter((item) => item.conteudo != null).length}
                    </button>
                  ) : (
                    <div>
                      {loading ? (
                        <div style={loa.loadingContainer}>
                          <CircularProgress />
                          <p>Carregando antigas...</p>
                        </div>
                      ) : (
                        <div>
                          {/* Conteúdo a ser exibido quando não estiver carregando */}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </td>
              <td style={styles.td}>
                <button
                  style={styles.button("#007bff")}
                  onClick={() => [setFiltro(true), setStatusFiltro("Aberto")]}
                ><b>
                    Abertos:
                  </b>
                  {meuSetor.filter((item) => item.Status.nome === "Aberto").length}
                </button>
              </td>
              <td style={styles.td}>
                <button
                  style={styles.button("#28a745")}
                  onClick={() => [setFiltro(true), setStatusFiltro("Iniciado")]}
                ><b>
                    Iniciados:
                  </b>
                  {meuSetor.filter((item) => item.Status.nome === "Iniciado").length}
                </button>
              </td>
              <td style={styles.td}>
                <button
                  style={styles.button(" #f29f20")}
                  onClick={() => [setFiltro(true), setStatusFiltro("Parado")]}
                ><b>
                    Parados:
                  </b>
                  {meuSetor.filter((item) => item.Status.nome === "Parado").length}
                </button>
              </td>

              <td style={styles.td}>
                <button
                  style={styles.button("#dc3545")}
                  onClick={() => [setFiltro(true), setStatusFiltro("Pendente")]}
                ><b>
                    Pendêntes:
                  </b>
                  {meuSetor.filter((item) => item.Status.nome === "Pendente").length}
                </button>
              </td>
              <td style={styles.td}>
                <button
                  style={styles.button("#17bbb8")}
                  onClick={() => [setFiltro(true), setStatusFiltro("Planejado para Iniciar")]}
                ><b>
                    Planejado para Iniciar:
                  </b>
                  {
                    meuSetor.filter(
                      (item) => item.Status.nome === "Planejado para Iniciar"
                    ).length
                  }
                </button>





              </td>

            </tr>
          </tbody>
        </table>

        {!checked && (
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
              margin: "20px 0"
            }}
          >
            <TextField
              fullWidth
              id="filled-basic"
              label="Pesquise por Protocolo"
              name="pesquisa"
              value={pesquisa}
              type="number"
              style={{ backgroundColor: "#FFFACD", borderRadius: "4px" }}
              onChange={(e) => setPesquisa(e.target.value)}
            />
            <p></p>
            {/* <Button type="button" className="btn btn-primary" onClick={(e) => { pesquisar() }}>Buscar </Button> */}
          </Box>
        )}



        {respostas ? (
          <center>
            <table
              className="table table-striped"
              style={{
                fontFamily: "arial",
                fontSize: "12px",
                marginLeft: 10,
                marginRight: 10,
                width: "100%",
              }}
            >
              <tbody>
                {respostas.map((item, index) => (
                  <tr key={index}>
                    <th scope="row" style={{ wordBreak: "break-all" }}>
                      {!item.fkUsuarioExecutor ? (
                        <div style={{ color: "red", size: 28 }}>
                          {" "}
                          Executor: &#10067;{" "}
                        </div>
                      ) : (
                        <div style={{ color: "Blue" }}>
                          {" "}
                          Executor: {item.UsuarioExecutor.nome}&#128587;{" "}
                        </div>
                      )}
                      {"Titulo: " + item.titulo}
                      <br></br>
                      {"Status : " + item.Status.nome}
                      {item.Status.nome == "Concluido" ? (
                        <a>&#9989;</a>
                      ) : (
                        <a> &#128341;</a>
                      )}
                      <br></br>
                      {item.categoria === ""
                        ? ""
                        : "Categoria : " + item.categoria}
                      <br></br>
                    </th>
                    <br></br>


                    <th>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                          (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${item.id}/edit`)
                        }
                      >
                        abrir atividade
                      </Button>
                    </th>
                  </tr>
                ))}
              </tbody>
            </table>
          </center>
        ) : (
          ""
        )}
      </center>
      <SpeedDial
        ariaLabel="Nova Tarefa"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
        icon={<EditIcon />}
        onClick={() =>
          (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/cadastro`)
        }
      />

      <hr></hr>



      {logged && logged.Area.Unidade.nome !== 'Faculdade' ?
        <div>
          {minhas == true ? (
            <div style={{ fontSize: "18px" }}>
              {" "}
              <center>
                Minhas Pendências<br></br>
              </center>
            </div>
          ) : (
            <div style={{ fontSize: "18px" }}>
              {" "}
              <center>
                Pêndencias do Setor<br></br>
              </center>
            </div>
          )}

        </div>
        : ''}









      {meuSetor.length === 0 ? (
        <div style={{ color: "red" }}>
          <center>
            Seu setor não usa o Task Manager para receber e gerenciar tarefas?
            <br></br>
            Controle por Funcionário, por Status, por criticidade, tudo no
            celular.<br></br>Habilite essa função com a GTI
          </center>{" "}
        </div>
      ) : (
        ""
      )}

      <table
        style={{
          backgroundColor: "#FFFACD",
          height: "100%",
          paddingRight: "10px",
          borderCollapse: "collapse",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.5)",
          borderRadius: "10px",
        }}
      >
        {logged && logged?.Area?.Unidade?.nome !== 'Faculdade' ?
          <div>
            <Checkbox
              id="meu"
              minhas={minhas}
              onChange={Change}
              color="primary"
              inputProps={{ "aria-label": "checkbox example" }}
              checked={minhas}
            />
            <label htmlFor="meu" style={{ paddingRight: "10px" }}>
              Minhas Pendências
            </label>

          </div>
          : ''
        }

        {logged && logged?.Area?.Unidade?.nome === 'Faculdade' && (
          logged.email === 'silvioartur@pe.senac.br' ||
          logged.email === 'marcossalgueiro@pe.senac.br' ||
          logged.email === 'danilogusmao@pe.senac.br' ||
          logged.email === 'wellingtonfranca@pe.senac.br' ||
          logged.email === 'wellingtonfranca@pe.senac.br' ||
          logged.email === 'marconunes@pe.senac.br'

        ) ?
          <div
          >
            <Checkbox
              id="meu"
              minhas={minhas}
              onChange={Change}
              color="primary"
              inputProps={{ "aria-label": "checkbox example" }}
              checked={minhas}
            />
            <label htmlFor="meu" style={{ paddingRight: "10px" }}>
              Minhas Pendências
            </label>

          </div>
          : ''
        }


      </table>
      <p></p>

      <table
        className="table table-striped"
        style={{
          fontFamily: "arial",
          fontSize: "12px",
          marginLeft: 10,
          marginRight: 20,
          borderCollapse: "collapse",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
          borderRadius: "3px",
        }}
      >
        {minhas === false ? (
          <tbody>
            {meuSetor
              .filter(
                (item) =>
                  item.Status.nome !== "Concluido" &&
                  item.Status.nome !== "Cancelado"
              )
              .map((item, index) => (
                <tr
                  key={index}
                  onClick={() =>
                    (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${item.id}/edit`)
                  }
                  style={{
                    cursor: "pointer",
                    borderBottom: "2px solid #ddd",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0px 4px 8px rgba(0, 0, 0, 0.2)";
                    e.currentTarget.style.transform = "scale(1.02)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <th
                    scope="row"
                    style={{
                      wordBreak: "break-word",
                      padding: "16px",
                      textAlign: "left",
                      color: "#333",
                    }}
                  >
                    <div style={{ display: "flex", gap: "8px" }}>
                      <div style={{ marginBottom: "8px" }}>
                        <StatusButton status={item.Status.nome} />
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <PrioridadeButton status={item.Classificacao.nome} />
                      </div>
                    </div>




                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        marginBottom: "8px",
                      }}
                    >
                      Título: {item.titulo}
                    </div>
                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Solicitado em:</strong>{" "}
                      {new Date(item.createdAt).toLocaleString()}
                    </div>
                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Solicitado por:</strong>{" "}
                      {item.Usuario ? item.Usuario.nome : ""}
                    </div>

                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Unidade Demandante:</strong>{" "}
                      {item.Usuario ? item.Usuario.Area.Unidade.nome : ""}
                    </div>
                    {item.fkUsuarioExecutor ? (
                      <div
                        style={{
                          color: "#007bff",
                          fontWeight: "bold",
                          marginTop: "8px",
                        }}
                      >
                        Executor: {item.UsuarioExecutor ? item.UsuarioExecutor.nome : ""}
                        &#128590;
                      </div>
                    ) : (
                      <div
                        style={{
                          color: "#dc3545",
                          fontWeight: "bold",
                          marginTop: "8px",
                        }}
                      >
                        Selecione o executor &#10067;
                      </div>
                    )}
                  </th>
                </tr>
              ))}
          </tbody>

        ) : (
          <tbody>
            {meuSetor
              .filter(
                (item) =>
                  item.fkUsuarioExecutor === logged.id &&
                  item.Status.nome !== "Concluido" &&
                  item.Status.nome !== "Cancelado"
              )
              .map((item, index) => (
                <tr
                  key={index}
                  onClick={() =>
                    (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${item.id}/edit`)
                  }
                  style={{
                    display: "table-row",
                    backgroundColor: "#fdfdfd",
                    borderBottom: "2px solid #e0e0e0",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    padding: "12px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    cursor: "pointer",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0px 6px 12px rgba(0, 0, 0, 0.2)";
                    e.currentTarget.style.transform = "scale(1.02)";

                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
                    e.currentTarget.style.transform = "scale(1)";

                  }}
                >
                  <th
                    scope="row"
                    style={{
                      wordBreak: "break-word",
                      textAlign: "left",
                      padding: "16px",
                      color: "#333",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    <div style={{ display: "flex", gap: "8px" }}>
                      <div style={{ marginBottom: "8px" }}>
                        <StatusButton status={item.Status.nome} />
                      </div>

                      <div style={{ marginBottom: "8px" }}>
                        <PrioridadeButton status={item.Classificacao.nome} />
                      </div>
                    </div>


                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        marginBottom: "8px",
                      }}
                    >



                      Título: {item.titulo}
                    </div>
                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Solicitado em:</strong> {new Date(item.createdAt).toLocaleString()}
                    </div>
                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Solicitado por:</strong> {item.Usuario ? item.Usuario.nome : ""}
                    </div>

                    <div style={{ marginBottom: "6px", color: "#555" }}>
                      <strong>Unidade Demandante:</strong>{" "}
                      {item.Usuario ? item.Usuario.Area.Unidade.nome : ""}
                    </div>
                    {item.fkUsuarioExecutor ? (
                      <div
                        style={{
                          color: "#007bff",
                          fontWeight: "bold",
                          marginTop: "8px",
                        }}
                      >
                        Executor: {item.UsuarioExecutor.nome} &#128590;
                      </div>
                    ) : (
                      <div
                        style={{
                          color: "#dc3545",
                          fontWeight: "bold",
                          marginTop: "8px",
                        }}
                      >
                        Selecione o executor &#10067;
                      </div>
                    )}
                  </th>
                </tr>
              ))}
          </tbody>

        )}
      </table>

      <Dialog open={emailNaoEncontrado}>
        <DialogContent>
          <hr></hr>
          <h4>Questionário de Satisfação do Usuário de TI</h4>
          Agradecemos por dedicar um tempo para nos fornecer feedback valioso
          sobre os serviços de Tecnologia da Informação (TI) da nossa
          organização. Sua opinião é importante para melhorarmos continuamente
          nossos serviços. Este questionário levará apenas alguns minutos para
          ser concluído.
          <center>
            <Button
              variant="contained"
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/pesquisa/`)
              }
            >
              Responder
            </Button>
            <p></p>
            <Button
              variant="contained"
              onClick={() => [setEmailNaoEncontrado(false), setFechar(true)]}
            >
              Sair
            </Button>
          </center>
          {/* <Button variant="contained" onClick={novaInteracao}>{'Enviar'}</Button>


    <Button onClick={() => setOpenMsg(false)}>Cancelar</Button> */}
        </DialogContent>





      </Dialog>



      {showModal1 && (
        <div>


          <Dialog
            style={{
              fontFamily: "arial",
              fontSize: "12px",
              marginLeft: 10,
              marginRight: 20,
              borderCollapse: "collapse",
              boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
              borderRadius: "3px",
            }}
            open={showModal1}>
            <DialogContent>

              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                <h3 style={{ fontSize: '22px', color: '#333', fontWeight: 'bold', marginBottom: '12px' }}>
                  Atividades abertas há mais de <b styles={{ color: 'red' }}>15 dias </b> e não concluídas
                </h3>
                <b style={{ fontSize: '18px', color: '#555', display: 'block', marginBottom: '10px' }}>
                  Suas Opções:
                </b>

                <ol style={{ paddingLeft: '20px', lineHeight: '1.8', fontSize: '16px', color: '#666' }}>
                  <li>Cancelar atividade</li>
                  <li>Arquivar atividade</li>
                  <li>
                    Deixar uma mensagem explicando a impossibilidade de cancelar ou arquivar a atividade, caso não possa realizar essas ações.
                  </li>
                </ol>
              </div>

              <div>
                <table style={styles1.table}>

                  <tbody>
                    {minhasAtividadesAntigas.length > 0 ? (

                      minhasAtividadesAntigas
                        .filter((atividade) => atividade.conteudo != null)
                        .map((atividade, index) => (

                          <tr key={index} style={{ padding: '20px', backgroundColor: '#FCEE9F', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
                            <hr></hr>
                            <td style={styles1.tableCell}>
                              <div style={styles1.activityDetails}>
                                <div style={styles1.activityTitle}>
                                  <strong>Título:</strong> {atividade.titulo}
                                </div>
                                <div style={styles1.activityDate}>
                                  <strong>Criado há:</strong> {atividade.createdAt ? `${calculateDaysSince(atividade.createdAt)} dias` : 'Data não disponível'}
                                </div>
                              </div>
                              <Button
                                variant="contained"
                                size="small"
                                style={styles1.resolveButton}
                                onClick={() => (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${atividade.id}/edit`)}
                              >
                                Resolver Agora
                              </Button>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="3" style={styles1.noActivities}>
                          Sem atividades para listar
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

              </div>

              <p></p>

              <Button

                onClick={() => setShowModal1(false)}
              >
                resolver depois
              </Button>
            </DialogContent>

          </Dialog>

        </div>


      )}


      <Dialog open={filtro} style={styles1.dialog}>
        <DialogContent style={styles1.dialogContent}>

          <hr />
          <table>
            {logged ?
              <div>
                <Box
                  sx={{
                    width: 500,
                    maxWidth: "100%",
                    margin: "20px 0",
                    backgroundColor: '#F4DE66'

                  }}
                >


                  <Checkbox

                    id="meu"
                    minhas={minhas2}
                    onChange={Change2}
                    color="primary"
                    inputProps={{ "aria-label": "checkbox example" }}
                    checked={minhas2}
                  />
                  <label htmlFor="meu" style={{ paddingRight: "10px" }}>
                    Minhas {statusFiltro}
                  </label>
                </Box>

              </div>
              : ''
            }

            {minhas2 === false ?
              <div>
                <tbody style={styles1.tableBody}>
                  <b>Todas: {statusFiltro}</b>
                  {meuSetor.length > 0 ?
                    <div>
                      {meuSetor
                        .filter((item) => item.Status.nome === statusFiltro)
                        .map((item, index) => (
                          <tr key={index} style={styles1.tableRow}>
                            <td style={styles1.tableCell}>
                              <div style={styles1.title}>Título: {item.titulo}</div>
                              <div style={styles1.detail}>
                                Solicitado: {new Date(item.createdAt).toLocaleString()}
                                <br />
                                Demandante: {item.Usuario ? item.Usuario.Area.Unidade.nome : ""}
                                <br />
                                {item.fkUsuarioExecutor ? (
                                  <div style={styles1.statusPending}>
                                    Executor: {item.UsuarioExecutor ? item.UsuarioExecutor.nome : ''} &#128590;
                                  </div>
                                ) : (
                                  <div style={{ color: "#dc3545", fontStyle: "italic" }}>
                                    Selecione o executor &#10067;
                                  </div>
                                )}
                                {item.Status.nome === "Concluido" ? (
                                  <div style={styles1.statusCompleted}>
                                    Status: {item.Status.nome} &#9989;
                                  </div>
                                ) : (
                                  <div style={styles1.statusPending}>
                                    Status: {item.Status.nome} &#x23F3;
                                  </div>
                                )}
                              </div>
                              <hr />
                            </td>
                            <td style={styles1.tableCell}>
                              <button
                                style={styles1.button}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles1.buttonHover.backgroundColor)}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = styles1.button.backgroundColor)}
                                onClick={() => (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${item.id}/edit`)}
                              >
                                Ver
                              </button>
                            </td>
                          </tr>
                        ))}

                    </div>
                    : 'Sem tarefas para listar'}

                </tbody>

              </div>
              :
              <div>
                <tbody style={styles1.tableBody}>
                  {meuSetor.length > 0 ?
                    <div>
                      <b>Minhas: {statusFiltro}</b>
                      {meuSetor
                        .filter((item) =>
                          item.Status &&
                          item.Status.nome === statusFiltro &&
                          logged &&
                          item.UsuarioExecutor &&
                          item.UsuarioExecutor.id === logged.id
                        ).map((item, index) => (
                          <tr key={index} style={styles1.tableRow}>
                            <td style={styles1.tableCell}>
                              <div style={styles1.title}>Título: {item.titulo}</div>
                              <div style={styles1.detail}>
                                Solicitado: {new Date(item.createdAt).toLocaleString()}
                                <br />
                                Demandante: {item.Usuario ? item.Usuario.Area.Unidade.nome : ""}
                                <br />
                                {item.fkUsuarioExecutor ? (
                                  <div style={styles1.statusPending}>
                                    Executor: {item.UsuarioExecutor.nome} &#128590;
                                  </div>
                                ) : (
                                  <div style={{ color: "#dc3545", fontStyle: "italic" }}>
                                    Selecione o executor &#10067;
                                  </div>
                                )}
                                {item.Status.nome === "Concluido" ? (
                                  <div style={styles1.statusCompleted}>
                                    Status: {item.Status.nome} &#9989;
                                  </div>
                                ) : (
                                  <div style={styles1.statusPending}>
                                    Status: {item.Status.nome} &#x23F3;
                                  </div>
                                )}
                              </div>
                              <hr />
                            </td>
                            <td style={styles1.tableCell}>
                              <button
                                style={styles1.button}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles1.buttonHover.backgroundColor)}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = styles1.button.backgroundColor)}
                                onClick={() => (window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${item.id}/edit`)}
                              >
                                Ver
                              </button>
                            </td>
                          </tr>
                        ))}

                    </div>
                    : 'Sem tarefas para listar'}

                </tbody>

              </div>}


          </table>
        </DialogContent>
        <div style={styles1.footer}>
          <Button
            variant="danger"
            onClick={() => [setEmailNaoEncontrado(false), setFiltro(false)]}
          >
            Sair
          </Button>
        </div>
      </Dialog>


    </div>
  );
};

export default Home;
